module.exports = __webpack_public_path__ + "static/media/w_y_18.940646e8.png";